// extracted by mini-css-extract-plugin
export default {"modal":"HrmnHC","form":"lDLT2K","input":"KF1GWy","error":"KE0M_T","submitButton":"bewMQm","title":"EdAOjU"};